// Shared option list for a user's occupation / role.
// Used by both the sign-up form and the profile editor so they stay consistent.
export const OCCUPATION_OPTIONS = [
  "K12 Students",
  "Undergraduate Students",
  "Graduate Student",
  "Academic Researcher",
  "Industry Researcher",
  "Infrastructure Engineer",
  "Other",
];
